module.exports = __webpack_public_path__ + "img/home.ccbd7f3.jpg";